module.exports = __webpack_public_path__ + "img/title_icon2.49d4cc34.svg";